import { render, staticRenderFns } from "./breadcrumbsList.vue?vue&type=template&id=86f879b4&scoped=true&"
import script from "./breadcrumbsList.vue?vue&type=script&lang=js&"
export * from "./breadcrumbsList.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumbsList.vue?vue&type=style&index=0&id=86f879b4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f879b4",
  null
  
)

export default component.exports